<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="false"
    :max-width="480"
    :persistent="true"
  >
    <template slot="header">
      <span>Schedule Truck Request #{{ item && item.id ? item.id : '' }}</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col class="pb-0">
          <v-date-picker
            v-model="selectedDate"
            full-width
            :allowed-dates="allowedDates"
            @change="getScheduledDeliveries(selectedDate)"
          />
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="11" class="pl-2 pr-2">
          <v-autocomplete
            v-model="item.request_shift_id"
            :items="shifts"
            item-text="name"
            item-value="id"
            clearable
            :rules="[(v) => !!v || 'Shift is required']"
          >
            <template #item="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #selection="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
            <template slot="label">
              Shift<RedAsterisk/>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <!-- <v-row justify="center" align="center">
        <v-col cols="11" class="pb-0 pl-2 pr-2">
          <v-autocomplete
            v-model="scheduledDeliveryId"
            :items="scheduledDeliveries"
            item-text="title"
            item-value="id"
            label="Add To Scheduled Delivery"
            clearable
            :disabled="!selectedDate"
            :loading="loadingScheduledDeliveries"
            :hide-details="true"
          >
            <template #item="{ item }">
              <span style="font-weight: bold">
                {{ item.title }}
              </span>
            </template>
            <template #selection="{ item }">
              <span style="font-weight: bold">
                {{ item.title }}
              </span>
            </template>
            <template #append-outer>
              <v-tooltip top>
                <template #activator="{ on, attrs }">
                  <v-btn
                    v-on="on"
                    v-bind="attrs"
                    color="primary"
                    outlined
                    small
                    :disabled="!scheduledDeliveryId || !selectedDate"
                    @click="addToScheduledDelivery"
                  >
                    <v-icon> mdi-plus </v-icon>
                  </v-btn>
                </template>
                <span> Click to Add to Scheduled Delivery </span>
              </v-tooltip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pb-0 text-center"> OR </v-col>
      </v-row> -->
      <v-row justify="center" align="center">
        <v-col cols="11" class="pl-2 pr-2">
          <v-btn
            color="primary"
            block
            outlined
            :disabled="!selectedDate || loadingScheduledDeliveries"
            @click="scheduleTruckRequest"
          >
            SCHEDULE
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <confirm-form ref="confirmForm" />
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  components: {},
  props: {},
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      request_type_id: null,
      date: new Date().toISOString().slice(0, 10),
      truck_types: [],
      trucks: [],
      job_id: null,
      project_id: null,
      inventory_class_id: null,
      big_cage_quantity: 0,
      small_cage_quantity: 0,
      request_shift_id: null,
      comment: null,
    },

    scheduledDeliveries: [],
    shifts: [],

    truckScheduleStatusInProgress: 2,
    truckScheduleRequestShiftIdPending: 1,
    truckScheduleRequestTypeIdPickup: 1,

    scheduledDeliveryId: null,
    selectedDate: null,
    loadingScheduledDeliveries: false,
    // isInitialTruckRequestPending: false,
  }),
  watch: {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([]),
    // minScheduledDeliveryDate() {
    //   return moment(new Date().toLocaleDateString('en-US')).format(
    //     'YYYY-MM-DD'
    //   );
    // },
  },
  watch: {},
  created() {
    this.item = { ...this.itemDto };
  },
  mounted() {
    this.item = { ...this.itemDto };
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    async open(item) {
      this.$bus.$emit('loading');
      this.scheduledDeliveryId = null;
      this.selectedDate = null;
      // this.isInitialTruckRequestPending = false;
      this.$refs.dialogBox.open();
      if (!item) {
        this.$refs.dialogBox.close();
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Truck request not found');
        return;
      } 
      // if (item.request_shift_id === this.truckScheduleRequestShiftIdPending) {
      //   this.isInitialTruckRequestPending = true;
      // }
      this.item = JSON.parse(JSON.stringify(item));
      this.getShifts();
      this.$bus.$emit('loading-stop');
    },

    async getScheduledDeliveries(date) {
      this.loadingScheduledDeliveries = true;
      const submitModel = {
        filters: {
          date: date,
          not_id: this.item.slot_id,
        },
      };
      const res = await this.$api.truckScheduleSlot.read(submitModel);
      if (!res) {
        this.$bus.$emit('showError', 'Unable to retrieve scheduled deliveries');
        this.loadingScheduledDeliveries = false;
        return;
      }
      this.scheduledDeliveries = res;
      this.loadingScheduledDeliveries = false;
    },

    async getShifts() {
      const res = await this.$api.truckScheduleRequestShift.get();
      if (!res) return;
      this.shifts = res;
    },

    async scheduleTruckRequest() {
      const truckRequest = JSON.parse(JSON.stringify(this.item));
      const currentSlotId = truckRequest.slot?.id;
      // if (this.isExistingJobAcrossScheduledDeliveries(truckRequest, this.selectedDate)) {
      //   this.$bus.$emit('showError', `A Scheduled Delivery already exists with this Job for this date`);
      //   return;
      // }

      // let res = null;
      // const res = await this.createNewScheduledDeliveryAndAddTruckRequest(truckRequest);
      // if (this.isTruckRequestNonPendingPickup(truckRequest)) {
      //   const pickupScheduledDeliveryId = this.isExistingNonPendingPickupAcrossScheduledDeliveryDate(this.selectedDate);  //done
      //   if (pickupScheduledDeliveryId) {
      //     res = await this.addTruckRequestToScheduledDelivery(pickupScheduledDeliveryId);
      //   } else {
      //     res = await this.createNewScheduledDeliveryAndAddTruckRequest(truckRequest);
      //   }
      // } else if (this.isTruckRequestPending(truckRequest)) {
      //   const pendingScheduledDeliveryId = this.isExistingPendingAcrossScheduledDeliveryDate(this.selectedDate); //done
      //   if (pendingScheduledDeliveryId) {
      //     res = await this.addTruckRequestToScheduledDelivery(pendingScheduledDeliveryId);
      //   } else {
      //     res = await this.createNewScheduledDeliveryAndAddTruckRequest(truckRequest);
      //   }
      // } else {
      //   const scheduledDeliveryId = this.isExistingInventoryClassAcrossScheduledDeliveries(truckRequest, this.selectedDate); //done
      //   if (scheduledDeliveryId) {
      //     res = await this.addTruckRequestToScheduledDelivery(scheduledDeliveryId);
      //   } else {
      //     res = await this.createNewScheduledDeliveryAndAddTruckRequest(truckRequest);
      //   }
      // }

      truckRequest.slot_id = null;
      const newTruckSchedule = {
        id: 0,
        request: truckRequest,
        date: this.selectedDate,
      };
      //submit a new truck_schedule_slot
      const res = await this.$api.truckScheduleSlot.store(newTruckSchedule);

      const httpStatusCodeConflict = 409;
      const httpStatusCodeNotExtended = 510;
      if (res.status === httpStatusCodeConflict || res.status === httpStatusCodeNotExtended) {
        this.$bus.$emit('showError', res.message);
        return;
      }

      if (!res) {
        this.$bus.$emit('showError', 'Unable to schedule truck request');
        return;
      }

      // depracted code
      // if (this.truckRequestHasUnactivatedPickLists(truckRequest)) {
      //   const isActive = 1;
      //   const res2 = await this.$api.partPickList.get(`is-active/truck-schedule-request/${truckRequest.id}/${isActive}`);
      //   if (!res2) {
      //     this.$bus.$emit(
      //       'showError',
      //       `Error activating Pick List for Truck Schedule Request`
      //     );
      //     return;
      //   }
      // }

      //on success, show success message and refresh the calendar
      this.$emit('success', currentSlotId);
      this.$refs.dialogBox.close();
    },

    async addTruckRequestToScheduledDelivery(scheduledDeliveryId) {
      this.item.slot_id = scheduledDeliveryId;
      this.item.status_id = this.truckScheduleStatusInProgress;

      let res;
      try {
        res = await this.$api.truckScheduleRequest.update(this.item);
      } catch (error) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit(
          'showError',
          error.response && typeof error.response.data === 'string' && error.response.data
            ? error.response.data
            : 'Error adding Truck Request to Scheduled Delivery'
        );
        return false;
      }

      if (!res) {
        this.$bus.$emit(
          'showError',
          `Error adding Truck Request to Scheduled Delivery`
        );
        return false;
      }
      return true;
    },

    async createNewScheduledDeliveryAndAddTruckRequest(truckRequest) {
      //need to set truckRequest.slot_id to null to associate this TR to the new SD when rescheduleing 
      //but will always be null if scheduling from scratch
      truckRequest.slot_id = null;
      const newTruckSchedule = {
        id: 0,
        request: truckRequest,
        date: this.selectedDate,
      };
      //submit a new truck_schedule_slot
      const res = await this.$api.truckScheduleSlot.store(newTruckSchedule);

      if (!res) {
        return false;
      }
      return true
    },

    // isSameClass(truckRequest, event) {
    //   if (event.requests == null || event.requests.length <= 0) return true;
    //   return truckRequest.inventory_class_id === event.requests[0].class.id;
    // },

    // isExistingJobInScheduledDelivery(truckRequest, event) {
    //   const jobId = truckRequest.job_id;
    //   const requests = Array.isArray(event.requests) ? event.requests : [];
    //   return requests.some((x) => x.job_id === jobId);
    // },

    // isExistingJobAcrossScheduledDeliveries(truckRequest, date) {
    //   const jobId = truckRequest.job_id;
    //   return this.scheduledDeliveries
    //     .filter((sd) => sd.date === date)
    //     .some((sd) =>
    //       sd.requests.some((r) => r.job_id === jobId)
    //     );
    // },

    // isExistingInventoryClassAcrossScheduledDeliveries(truckRequest, date) {
    //   // instead of only checking if there's a scheduled delivery with the same inventory class, we need to return the id of the scheduled delivery
    //   const inventoryClassId = truckRequest.inventory_class_id;
    //   const scheduledDelivery = this.scheduledDeliveries
    //     .filter((sd) => sd.date === date)
    //     .find((sd) =>
    //       sd.requests.some(
    //         (r) => r.inventory_class_id === inventoryClassId
    //       )
    //     );
      
    //   return scheduledDelivery ? scheduledDelivery.id : null;
    // },

    isTruckRequestPending(truckRequest) {
      return truckRequest.request_shift_id === this.truckScheduleRequestShiftIdPending;
    },

    isTruckRequestPickup(truckRequest) {
      return truckRequest.request_type_id === this.truckScheduleRequestTypeIdPickup;
    },

    isTruckRequestNonPendingPickup(truckRequest) {
      return !this.isTruckRequestPending(truckRequest) && this.isTruckRequestPickup(truckRequest);
    },

    isScheduledDeliveryPending(scheduledDelivery) {
      // return scheduledDelivery.requests.some(
      //   (r) => r.request_shift_id === this.truckScheduleRequestShiftIdPending
      // );
      return scheduledDelivery.request && scheduledDelivery.request.request_shift_id === this.truckScheduleRequestShiftIdPending;
    },

    isScheduledDeliveryPickup(scheduledDelivery) {
      // return scheduledDelivery.requests.some(
      //   (r) => r.request_type_id === this.truckScheduleRequestTypeIdPickup
      // );
      return scheduledDelivery.request && scheduledDelivery.request.request_type_id === this.truckScheduleRequestTypeIdPickup;
    },

    isScheduledDeliveryNonPendingPickup(scheduledDelivery) {
      // return scheduledDelivery.requests.some(
      //   (request) =>
      //     request.request_shift_id !== this.truckScheduleRequestShiftIdPending &&
      //     request.request_type_id === this.truckScheduleRequestTypeIdPickup
      // );
      return scheduledDelivery.request && scheduledDelivery.request.request_shift_id !== this.truckScheduleRequestShiftIdPending &&
             scheduledDelivery.request.request_type_id === this.truckScheduleRequestTypeIdPickup;
    },

    isExistingPendingAcrossScheduledDeliveryDate(date) {
      // return this.scheduledDeliveries
      //   .filter((sd) => sd.date === date)
      //   .some((sd) => this.isScheduledDeliveryPending(sd));
      // instead of only checking if there's a pending scheduled delivery, we need to return the id of the pending scheduled delivery
      const pendingScheduledDelivery = this.scheduledDeliveries
        .filter((sd) => sd.date === date)
        .find((sd) => this.isScheduledDeliveryPending(sd));

      return pendingScheduledDelivery ? pendingScheduledDelivery.id : null;
    },

    isExistingPickupAcrossScheduledDeliveryDate(date) {
      // return this.scheduledDeliveries
      //   .filter((sd) => sd.date === date)
      //   .some((sd) => this.isScheduledDeliveryPickup(sd));
      // instead of only checking if there's a pickup scheduled delivery, we need to return the id of the pickup scheduled delivery
      const pickupScheduledDelivery = this.scheduledDeliveries
        .filter((sd) => sd.date === date)
        .find((sd) => this.isScheduledDeliveryPickup(sd));

      return pickupScheduledDelivery ? pickupScheduledDelivery.id : null;
    },

    isExistingNonPendingPickupAcrossScheduledDeliveryDate(date) {
      const pickupScheduledDelivery = this.scheduledDeliveries
        .filter((sd) => sd.date === date)
        .find((sd) => this.isScheduledDeliveryNonPendingPickup(sd));

      return pickupScheduledDelivery ? pickupScheduledDelivery.id : null;
    },

    truckRequestHasUnactivatedPickLists(truckRequest) {
      if (Array.isArray(truckRequest.pick_lists) && truckRequest.pick_lists.length > 0) {
        return truckRequest.pick_lists.some((pl) => pl.is_active === 0);
      }
      return false;
    },

    allowedDates(date) {
      // Allow all dates except Sundays
      const day = new Date(date + 'T00:00:00').getDay(); // correct timezone shift
      return day !== 0;
    },
  },
};
</script>